module.exports = function () {
	var $container = $('.product-search-bar');

	if ($container.length) {
		var typeAheadObject = Innophos.Modules.ProductSearchBar.TypeAhead($container);
		Innophos.Modules.ProductSearchBar.TypeAheadDropdown($container);

		var $searchInput = $('.product-search-bar .generic-search-bar__input');
		var $searchInner = $('.product-search-bar .generic-search-bar__inner');
		var searchInnerActiveClass = 'has-suggestions';

		var $bar = $('.product-search-bar__content-outer');
		var $barSentinel = $('.product-search-bar__sentinel');
		var barActiveClass = 'product-search-bar__content-outer--fixed';

		var searchResultsOffsetTop = $('.C2-search-results').offset().top;
		var searchResultsOuterHeight = $('.C2-search-results__wrapper').outerHeight(true);
		var barSentinelOffsetTop = $barSentinel.offset().top;

		var resetOffets = function() {
			searchResultsOffsetTop = $('.C2-search-results').offset().top;
			searchResultsOuterHeight = $('.C2-search-results__wrapper').outerHeight(true);
			barSentinelOffsetTop = $barSentinel.offset().top;
		}

		var setBarPosition = function () {
			var $searchResultsTop = $('.C2-search-results__inner__top');
			var $searchResultsTopParent = $searchResultsTop.parent();
			var $searchResultsTopHeight = $searchResultsTop.height();
			var barOffset = 32;
			var scrolledHeaderHeight = 57;
			var offset = barOffset + scrolledHeaderHeight;
			if ($(window).scrollTop() >= barSentinelOffsetTop &&
				$(document).scrollTop() + offset < searchResultsOffsetTop + searchResultsOuterHeight) {
				$bar.addClass(barActiveClass);
				$('.C2-search-results').addClass('with-sticky-search-bar');
			} else {
				$bar.removeClass(barActiveClass);
				$('.C2-search-results').removeClass('with-sticky-search-bar');
			}
		};

		$searchInput.focusout(function () {
			$searchInner.removeClass(searchInnerActiveClass);
		});

		$searchInput.focus(function () {
			var currentVal = $(this).val();

			if (!currentVal.length) {
				$searchInner.addClass(searchInnerActiveClass);
			}
			else {
				$searchInner.removeClass(searchInnerActiveClass);
			}
		});

		$searchInput.on('input', function (e) {
			var currentVal = $searchInput.val();

			if (currentVal.length) {
				
			}
			if (!currentVal.length) {
				$searchInner.addClass(searchInnerActiveClass);
				
			}
			else if (!$searchInner.hasClass('has-dropdown-suggestions'))
			{
				$searchInner.removeClass(searchInnerActiveClass);
			}
		});

		var setClearButtonVisibility = function (inputValue) {
			if (inputValue) {
				$container.find('.search-bar__reset').addClass('search-bar__reset--visible');
			} else {
				$container.find('.search-bar__reset').removeClass('search-bar__reset--visible');
				typeAheadObject.clearTypeAhead();
			}
		};

		$searchInput.keyup(function () {
			setClearButtonVisibility($(this).val());
		});

		$container.find('.search-bar__reset').click(function () {
			setClearButtonVisibility();
		});

		$(window).scroll(function () {
			requestAnimationFrame(setBarPosition);
		});

		$(window).resize(function () {
			resetOffets();
			requestAnimationFrame(setBarPosition);
		});

		setBarPosition();
	}
};
